import script from "./WelcomeScreenView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WelcomeScreenView.vue?vue&type=script&lang=ts&setup=true"

import "./WelcomeScreenView.vue?vue&type=style&index=0&id=b1e1efa0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1e1efa0"]])

export default __exports__